import { buildCommonTransfer } from "@/components/excel/schema/label/transfer/base";
import {
  HourOption,
  MinuteOption,
  SecondOption,
} from "@/components/excel/schema/label/type/time";

export const TimeValueTransfer = {
  ...buildCommonTransfer(HourOption),
  ...buildCommonTransfer(MinuteOption),
  ...buildCommonTransfer(SecondOption),
};
